export const initialState = {
	initialized: false,
	loading: false,
	fetched: false,
	hasError: false,
	aborted: false,
	error: undefined,
	data: undefined,
} as const;
